// components/GlobalLoader.js
import React from 'react';
import './loader.css';

const GlobalLoader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="global-loader-overlay">
      <div className="ball-loader">
        {[...Array(6)].map((_, i) => (
          <div key={i} className={`ball ball${i + 1}`} />
        ))}
      </div>
    </div>
  );
};

export default GlobalLoader;
